import { useConfigStore } from '~/stores/config';

/**
 * Counterpart to `06.schools-unavailable` for the other door (CP-11590): a page that declares
 * `unavailableOnConsumer` in its meta is sent to the consumer home on consumer clusters. The
 * schools public landings live in `pages/unified/`, whose `/unified` prefix the `pages:extend`
 * hook strips on every cluster, so without this they would answer on the consumer host too.
 *
 * No per-page redirect target, unlike its schools counterpart: a schools landing has no consumer
 * equivalent to send a visitor to, so they all go home.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (!to.meta.unavailableOnConsumer) {
    return;
  }

  if (useConfigStore().isSchoolsCluster) {
    return;
  }

  return navigateTo(clusterRedirectPath('/'), { replace: true });
});
